import React from 'react';

export const NCSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="29"
    height="13"
    viewBox="0 0 28 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M184.756 118.198C185.904 126.537 194.288 131.68 190.046 142.815C209.26 142.815 226.328 143.015 243.396 142.715C249.235 142.616 254.026 142.965 257.22 150.006C263.907 164.936 274.488 175.372 287.014 183.461C290.607 185.758 295.498 188.404 296.746 192.199C304.132 215.118 321.699 207.878 335.723 210.824C341.063 211.973 342.81 208.877 344.806 202.385C353.689 173.524 371.506 154.649 396.858 145.861C399.104 145.112 400.601 140.818 402.997 142.915C418.268 156.147 425.854 143.564 434.388 131.331C440.975 121.893 449.26 115.851 460.389 113.355C475.81 109.859 480.601 92.7824 474.313 74.6067C466.577 52.1868 459.89 29.3174 452.254 5.09987H440.476C346.503 5.09987 252.479 5.1498 158.505 5C150.77 5 146.727 6.29826 142.735 16.2849C138.842 25.922 132.504 38.0058 119.828 38.555C112.541 38.9046 111.144 49.1908 104.856 51.4877C95.5732 45.9451 88.7859 44.547 80.6012 56.7806C72.217 69.2139 60.8882 80.2492 44.9681 80.6986C35.4359 80.9482 26.9518 84.2937 22.2107 96.2777C19.5657 102.869 13.3773 106.814 6.68984 105.266C2.54761 114.154 7.03918 120.295 9.33488 127.286C34.9868 125.738 61.537 126.437 87.2887 121.694C102.261 118.947 116.584 112.406 132.354 113.654C143.982 114.553 155.411 118.548 167.289 116.9C170.333 116.501 172.479 117.649 173.826 122.443C175.723 129.034 180.813 125.239 184.706 124.04"
        fill="white"
        stroke="currentColor"
        strokeWidth={20}
        transform="matrix(0.0580913,0,0,0.0599078,0,0)"
      />
    </g>
  </svg>
);

export default NCSvg;
